import { Page } from "../components/ui.jsx";
import { DREAM_TEAMS, JOIN_STEPS } from "../data/dreamteam.js";
import { LINKS } from "../data/site.js";

export default function DreamTeam({ back }) {
  return (
    <Page
      back={back}
      eyebrow="CLLXTV Dream Team"
      title="You were made to make history."
      intro="Every team is an extension of one movement. Nobody warms a bench on the Dream Team — there's a spot where your gift meets a need and the whole room feels it. Ready to get in the game?"
    >
      <a
        className="card"
        href={LINKS.serveForm}
        target="_blank"
        rel="noreferrer"
        style={{ background: "#FFC800", borderColor: "#FFC800", textAlign: "center" }}
      >
        <div className="name" style={{ justifyContent: "center", fontSize: 17 }}>
          <span>🙌 I'm Ready — Get Me Started</span>
        </div>
        <div className="desc" style={{ color: "#0F0F0F", textAlign: "center" }}>
          Takes two minutes. A leader follows up with you personally.
        </div>
      </a>

      <div className="block" style={{ marginTop: 28 }}>
        <h3>The teams</h3>
        <p>
          A team carries the weight of Sunday — supporting every service so the room is
          ready.
        </p>
      </div>

      {DREAM_TEAMS.map((t) => (
        <div key={t.name} className="card">
          <div style={{ fontSize: 30 }}>{t.icon}</div>
          <div className="name" style={{ marginTop: 10 }}>
            <span>{t.name}</span>
            <span className="evtag">{t.cat}</span>
          </div>
          <div className="desc">{t.desc}</div>
        </div>
      ))}

      <div className="block" style={{ marginTop: 28 }}>
        <h3>How it works</h3>
      </div>

      {JOIN_STEPS.map((s, i) => (
        <div key={s.t} className="card">
          <div className="name">
            <span className="lead">
              <span className="stepnum">{i + 1}</span>
              <span>{s.t}</span>
            </span>
          </div>
          <div className="desc">{s.d}</div>
        </div>
      ))}

      <div className="card" style={{ textAlign: "center", marginTop: 24 }}>
        <div className="name" style={{ justifyContent: "center", fontSize: 18 }}>
          <span>The best seat in the house is on the team.</span>
        </div>
        <a
          href={LINKS.serveForm}
          target="_blank"
          rel="noreferrer"
          className="btn-post"
          style={{ display: "inline-block", marginTop: 16, textDecoration: "none" }}
        >
          🙌 Join the Dream Team
        </a>
      </div>
    </Page>
  );
}
